
/* eslint-disable no-param-reassign */
/* eslint-disable no-restricted-syntax */
import React, { Component } from "react";
import commonUtil from "../../../../utils/commonUtil";
import ItemList from "../../../../components/FAQ/components/ItemList";




class FAQContainerComponent extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const brand = commonUtil.getBrand();
    const colors = {
      LP: "#E10098",
      GAP: "#122344",
      PB: "#970400",
      PBK: "#74b0e2",
      WS: "#e81818",
      WLM: "#ed2724",
      TRU: "#007bff",
    };


    const handleToggle = (element) => {
      const isOpen = element.ariaExpanded === "true";
      const content = element.nextElementSibling;
      const text = content.querySelector("p");
      const headers = document.querySelectorAll("article button");
      for (const header of headers) {
        header.classList.remove("active");
        header.nextElementSibling.style.height = "0px";
        header.ariaExpanded = header.id === element.id ? `${!isOpen}` : "false";
      }
      if (!isOpen) {
        element.classList.add("active");
        content.style.height = `${text.clientHeight}px`;
      }
    };
    const { component, id } = this.props;
    const ver_mas_title = component && component?.ver_mas_redirect && component?.ver_mas_redirect?.title;
    const ver_mas_redirect = component && component?.ver_mas_redirect && component?.ver_mas_redirect?.href;


    return (
       
      <div className={`containerStyleFAQ${ver_mas_redirect ? '' : ' boxStyleFAQ'}`}>
        <div className="headerStyleFAQ">
          <img
            src={
              component?.icon ? component.icon : commonUtil.getAssetURL() +
              "/images/faqs/mr/preguntas_frecuentes.png"
            }
            alt="iconFAQ"
            width="56"
            height="56"
            className="FAQ-image"
          />
          <p className={ver_mas_redirect ? 'fontTitleStyleFAQHeading' : 'fontTitleStyleFAQ'}>{component?.label ? component.label : 'Preguntas frecuentes'}</p>
        </div>
        {component && component.faqs &&
          component.faqs?.map((item, index) => (
            <ItemList
              key={index}
              id={index}
              categoryID={id}
              handleToggle={handleToggle}
              faq={{
                header: item?.question,
                text: item?.answer,
              }}
              isVerMasRedirectBtn={ver_mas_redirect && ver_mas_title}
            />
          ))}
        <div>
        {ver_mas_redirect && ver_mas_title && 
          <a className="btnStyleFAQ" href={ver_mas_redirect}>
            <p className="fontTitleStyleFAQ" style={{ color: colors[brand] }}>
              {ver_mas_title}
            </p>
            <span>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 25"
                fill="none"
              >
                <path
                  d="M19 13.6582H13V19.6582H11V13.6582H5V11.6582H11V5.6582H13V11.6582H19V13.6582Z"
                  fill={colors[brand]}
                />
              </svg>
            </span>
          </a>
        }
        </div>
      </div>
    );
  }
}

export default FAQContainerComponent;
